<!-- 
  新建 跟进记录特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 地址 -->
    <v-address
      @change="addressSave"
      v-if="item.attr === 'address'"
      :attrValue="form.address">
    </v-address>
    <!-- 关联客户 -->
    <template v-else-if="item.attr === 'customerName'">
      <div class="customerType" v-if="item.fieldType === 40">
        <associated-field
          ref="associatedField"
          module="customerApi"
          fromMoudle="communicateApi"
          :item="item"
          :form="form"
          @addNew="addNew"
          @emitObj="changeCustomer"
          >
        </associated-field>
        <!-- 下拉选择框 自定义 -->
        <el-select
          :disabled="item.templateEditeble ? item.templateEditeble[templateId] === 1 : item.selectControl.nonEditable===1"
          v-if="formatIsSelectControl()"
          v-model="item.selectControl.attrValue"
          @change="selectHandle(item.attr)">
          <el-option
            v-for="arr in item.selectControl.valueArrMap"
            :key="arr.key"
            :label="arr.value"
            :value="arr.key">
          </el-option>
        </el-select>
      </div>
    </template>
    <!-- 联系人 -->
    <template v-else-if="item.attr === 'contactArray'">
      <associated-field
        ref="associatedField"
        v-if="form.customerName&&form.customerName.id"
        module="contactApi"
        :multiselect="true"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        @addNew="addNew"
        @emitObj="saveObj"
        >
      </associated-field>
      <span v-else>无</span>
    </template>
    <!-- 跟进业务 -->
    <template v-else-if="item.attr === 'communicateBusiness'">
      <div class="communicateType" v-if="item.fieldType === 41 && form.customerName && form.customerName.id">
         <!-- 下拉选择框 自定义 -->
        <el-select
          v-if="item.selectControl && item.selectControl.valueArrMap"
          v-model="item.selectControl.attrValue"
          @change="toggleModuleType(item.attr)">
          <el-option
            v-for="arr in item.selectControl.valueArrMap"
            :key="arr.key"
            :label="arr.value"
            :value="arr.key"
            :disabled="arr.enable !== 1">
          </el-option>
        </el-select>
        <associated-field
          ref="associatedField"
          :module="moduleType"
          :item="item"
          :form="form"
          :customerId="form.customerName.id"
          @addNew="addNew"
          >
        </associated-field>
      </div>
      <span v-else>无</span>
    </template>
    <!-- 拜访时间 -->
    <template v-else-if="item.attr === 'communicateTime'">
      <el-date-picker
        :class="{disable: item && item.nonEditable}"
        :editable="false"
        v-model="form[item.attr]"
        type="datetime"
        format="yyyy-MM-dd HH:mm"
        value-format="yyyy-MM-dd HH:mm"
        :picker-options="disableBefore"
        placeholder="选择日期时间">
      </el-date-picker>
    </template>
    <!-- 选择访客计划 -->
    <template v-else-if="item.attr === 'synchronizeCommunicatePlan'">
      <div class="item-select" v-if="form.customerName && form.customerName.id && form.communicateTime">
        <el-input
          readonly
          placeholder="请点击“选择”添加"
          v-if="!form[item.attr].id"
          v-model="form[item.attr].value"
        >
        </el-input>
        <span class="item" v-if="form && form[item.attr].id" >
          <span class="text">{{form[item.attr].value}}</span>
          <i class="del el-icon-close" @click="delVisit()"></i>
        </span>
        <el-button type="text" class="select-btn" @click="handleSelectPlan()">选择</el-button>
      </div>
      <span v-else>无</span>
    </template>  
  </div>
</template>

<script>
import Vue from 'vue'
import * as api from 'src/api'
import { mapActions } from 'vuex'
import vAddress from '../address'
import vSwitch from 'components/common/switch'
import multSelect from 'components/modal/mult-select'
import remoteSelect from '../remote-select'
import associatedField from '../associated-field'
let num = 0

export default {
  props: ['item', 'form'],
  data () {
    return {
      moduleType: this.item.selectControl ? this.item.selectControl.attrValue === 1 ? 'contractApi' : 'opportunityApi' : 'opportunityApi', // 跟进业务的类型
      nextRemind: true,
      // 选择联系人弹窗
      contactShow: false,
      disableBefore: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      templateId: 0
    }
  },
  computed: {
    customerName () {
      return this.form.customerName
    },
    communicateTime () {
      return this.form.communicateTime
    }
  },
  created () {
    if (this.form.synchronizeCommunicatePlan && this.form.synchronizeCommunicatePlan.id) {
      this.isGetVisitPlanInfo()
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    formatIsSelectControl () {
      if (this.form.customerName && this.item.selectControl && this.item.selectControl.valueArrMap) {
        if (this.item.customerStatusEnable && this.item.customerStatusEnable[this.templateId] === 1) {
          return true
        } else if (!this.item.customerStatusEnable) {
          return true
        }
        return false
      }
      return false
    },
    // 重置关联单据
    changeCustomer (obj) {
      if (this.item.selectControl) {
        if (obj.key) {
          this.item.selectControl.attrValue = obj.key + ''
        } else {
          this.item.selectControl.attrValue = ''
        }
        if (obj.templateId) {
          this.templateId = obj.templateId
        }
      }
      this.form.contactArray = []
      this.form.opportunityId = ''
      this.form.synchronizeCommunicatePlan = {id: '', value: ''}
    },
    addressSave (arr) {
      Vue.set(this.form, 'address', arr)
    },
    saveObj (obj) {
      this.form[this.item.attr] = obj
      this.setAttr(this.item.attr)
    },
    // 删除联系人
    del (i) {
      this.form[this.item.attr].splice(i, 1)
    },
    addNew (arr) {
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    },
    // 选择客户类型
    selectHandle (attr) {
      if (this.form[attr]) {
        this.form[attr].customerStatus = this.item.selectControl.attrValue
      } else {
        this.setAttr(this.item.attr)
      }
    },
    // 更改跟进业务类型
    toggleModuleType (attr) {
      this.form[attr] = {}
      if (this.item.selectControl.attrValue === 5) {
        this.moduleType = 'opportunityApi'
      } else {
        this.moduleType = 'contractApi'
      }
    },
    getVisitPlanInfo () {
      let url = `/communicatePlanApi/getAssociatedPlan.do`
      let params = {
        customerId: this.form.customerName.id,
        communicateTime: this.form.communicateTime
      }
      api.post(url, params, (data) => {
        num = 0
        if (data.communicatePlanArray.length) {
          this.form.synchronizeCommunicatePlan = {id: data.communicatePlanArray[0].id, value: data.communicatePlanArray[0].value}
        }
        this.$emit('getVisitPlanList', data.communicatePlanArray || [])
      })
    },
    isGetVisitPlanInfo () {
      if (this.form.customerName && this.form.customerName.id && this.form.communicateTime) {
        num++
        if (num === 1) {
          this.getVisitPlanInfo()
        } else {
          this.$emit('getVisitPlanList', [])
        }
      } else {
        this.form.synchronizeCommunicatePlan = {id: '', value: ''}
        this.$emit('getVisitPlanList', [])
      }
    },

    // 选择访客计划
    handleSelectPlan () {
      // 设置完成访客计划相关
      if (this.form) {
        this.$emit('communicatePlan', this.form.synchronizeCommunicatePlan.id ? this.form.synchronizeCommunicatePlan : {})
      }
    },

    // 删除同步的访客计划
    delVisit () {
      this.form.synchronizeCommunicatePlan = {id: '', value: ''}
    }
  },
  watch: {
    // 跟进记录监听客户与拜访时间是否选择，如果已选择请求同步完成访客计划的内容
    customerName () {
      this.isGetVisitPlanInfo()
    },
    communicateTime () {
      this.isGetVisitPlanInfo()
    }
  },
  components: {
    vAddress,
    multSelect,
    vSwitch,
    remoteSelect,
    associatedField
  }
}
</script>
<style lang="less">
  .customer {
    .customerType .el-select, .communicateType .el-select {
      .el-input__inner {
        border: 1px solid #bfcbd9 !important;
      }
    }
  }
</style>
<style lang="less" scoped>
  @import '../../../assets/less/remote-select.less';
  .customer {
    .item-select {
      .select-btn {
        right: 0px;
        background: #fff;
        padding-right: 10px;
        padding-left: 10px;
      }
      &.disable {
        background-color: #eef1f6;
        border: 1px solid #d1dbe5;
        color: #bbb;      
      }
      .detail-bg {
        top: 0;
      }        
      &.disable {
        background-color: #eef1f6;
        border: 1px solid #d1dbe5;
        color: #bbb;
        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          opacity: 0;
          cursor: not-allowed;
        }
      }
    }
    .customerType {
      display: flex; 
      .el-select {
        margin-left: 10px;
        width: 45%;
      }
    }
    .communicateType {
      display: flex;
      .el-select {
        width: 45%;
        margin-right: 10px;
      }
    }
    .disable {
      color: #bbb;
      opacity: 0.7;
      &:after {
        content: '';
        position: absolute;
        background-color: #eef1f6;
        border: 1px solid #d1dbe5;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// index.vue?f86368d2